import React from 'react';

import {
  Layout, message,  Row, Col
} from 'antd';
import TableWrapper from '../elements/TableWrapper';

import MiCompAPI from '../../util/api';
import { Link } from 'react-router-dom';
import img from './../../assets/img/At the office-pana 1.png';

const { Content } = Layout;


class ContractCarrier extends React.Component {

  constructor(props) {
    super(props);
    this.client_columns = [{
      title: 'Carrier Name',
      dataIndex: 'client_name',
      render: (text, record) =>   <Link to={{ pathname: '/commissioncenter', state: record["clientId"]  }}>{text}</Link> ,
      sorter: (a, b) => a.client_name.localeCompare(b.client_name),
      sortDirections: ["descend", "ascend"]

    }, {
      title: 'Phone No',
      dataIndex: 'primary_Contact_Phone',
      render: (text, record) =>text&& text.length === 10 ? <a href={"tel:+" + text}>{"(" + text.substring(0, 3) + ") " + text.substring(3, 6) + "-" + text.substring(6)}</a> : ""

    },  {
      title: 'Email',
      dataIndex: 'email',
      sorter: (a, b) => a.email.localeCompare(b.email),
      sortDirections: ["descend", "ascend"]
    }, {
      title: 'Tax Id',
      dataIndex: 'client_tax_id',
      render: (text, record) =>text&& text.length === 9 ? text.substring(0, 2) + "-" + text.substring(2) : ""
    }];
   
    this.state = {
      isLoading: true,
      clients: [],
     
    }
    this.api = new MiCompAPI(null);
  }
  componentDidMount = () => {
    this.getClients();
  }  
  getClients = () => {
    this.api.invoke("GetContractCarrier", "get", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          
          message.destroy();
          this.setState({
            loading: false,
            clients: data.data
          })
        } else {
          message.destroy();
          message.error(data.statusMessage, 4);
        }

      }
    });
  }


  render() {
    return (
      <Content>
        <div className="mi_main_div">
        <div className="mi_box_sd">
            <Row span={24}>
              <Col span={18}>
                <h4 className="mi_box_h4">Commission Center</h4>
              </Col>
              <Col span={6}>
                <img alt="example" style={{ height: '150px', marginTop: '-50px' }} src={img} />
              </Col>
            </Row>
          </div>
          <div className="div_TB">
          <TableWrapper rowKey="client_id" columns={this.client_columns} data={this.state.loading ? null : this.state.clients} loading={this.state.loading} title="Carriers" buttons={this.tableButtons} column_search="client_name" search={true} />
        </div>
        </div>
      </Content>
    )
  }
}
export default ContractCarrier;